import { motion } from "framer-motion";
import { Zap, Users, Plus, Package, UserPlus } from "lucide-react";
import { useLang } from "@/lib/i18n";

const tabsMeta = [
  { icon: Zap, name: "Arena", span: "md:col-span-2", testid: "tab-arena" },
  { icon: Users, name: "Squads", span: "", testid: "tab-squads" },
  { icon: Plus, name: "Pin +", span: "", accent: true, testid: "tab-pin" },
  { icon: Package, name: "Vault", span: "", testid: "tab-vault" },
  { icon: UserPlus, name: "Friends", span: "md:col-span-2", testid: "tab-friends" },
];

export default function FourTabs() {
  const { t } = useLang();
  const tabs = tabsMeta.map((tab, i) => ({ ...tab, ...t.tabs.items[i] }));
  return (
    <section className="py-24 md:py-32 border-b border-white/10">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-16 max-w-3xl">
          <p className="font-mono-pw uppercase text-xs tracking-[0.3em] text-[#E6FF00] mb-5">{t.tabs.overline}</p>
          <h2 className="font-anton uppercase leading-[0.9] text-5xl md:text-7xl">
            {t.tabs.headA} <span className="pw-outline-white">{t.tabs.headB}</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {tabs.map((tab, i) => {
            const Icon = tab.icon;
            return (
              <motion.div
                key={tab.name}
                initial={{ opacity: 0, scale: 0.97 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                data-testid={tab.testid}
                className={`group ${tab.span} p-8 md:p-10 min-h-[220px] flex flex-col justify-between transition-colors duration-300 ${
                  tab.accent ? "bg-[#E6FF00] text-black" : "bg-[#0A0A0A] hover:bg-[#111111]"
                }`}
              >
                <div className="flex items-center justify-between">
                  <Icon size={30} strokeWidth={1.75} className={tab.accent ? "text-black" : "text-[#E6FF00]"} />
                  <span className={`font-mono-pw uppercase text-[10px] tracking-[0.25em] ${tab.accent ? "text-black/60" : "text-white/40"}`}>
                    {tab.tag}
                  </span>
                </div>
                <div>
                  <h3 className="font-anton uppercase text-3xl md:text-4xl mb-2">{tab.name}</h3>
                  <p className={`font-body text-sm leading-relaxed ${tab.accent ? "text-black/70" : "text-white/60"}`}>
                    {tab.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
